export default __webpack_public_path__ + "static/media/character-akitoshi.15731739.png";